import { render } from "./ReviewJob.vue?vue&type=template&id=09a15674&scoped=true"
import script from "./ReviewJob.vue?vue&type=script&lang=js"
export * from "./ReviewJob.vue?vue&type=script&lang=js"

import "./ReviewJob.vue?vue&type=style&index=0&id=09a15674&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a15674"]])

export default __exports__